import 'rxjs/add/operator/toPromise';
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from 'firebase/app';
import {AngularFireDatabase} from '@angular/fire/database';
import {Injectable} from '@angular/core';
import {UserService} from '../core/user.service';

@Injectable()
export class AuthService {

  constructor(
   public afAuth: AngularFireAuth,
   private realtimeDB: AngularFireDatabase,
   public userService: UserService
  ) {}

  doRegister(value) {
    let fullName = value.firstName + " " +  value.lastName;
    return new Promise<any>((resolve, reject) => {
      firebase.auth().createUserWithEmailAndPassword(value.email, value.password)
      .then(data => {
        this.userService.updateCurrentUser(value);
        data.user.updateProfile({displayName: fullName});
        let postRef = this.realtimeDB.list('participants/' + data.user.uid);
        postRef.push({
          FIRST_NAME: value.firstName.trim(),
          LAST_NAME: value.lastName.trim(),
          PAYROLL: value.payroll,
          EMAIL: value.email,
        });
        resolve(data);
      }, err => reject(err));
    });
  }

  doLogin(value) {
    return new Promise<any>((resolve, reject) => {
      firebase.auth().signInWithEmailAndPassword(value.email, value.password)
      .then(res => {
        resolve(res);
      }, err => reject(err));
    });
  }

  doLogout() {
    return new Promise<void>((resolve, reject) => {
      if (firebase.auth().currentUser) {
        this.afAuth.auth.signOut();
        resolve();
      } else {
        reject();
      }
    });
  }

  doResetPassword(email) {
    return new Promise<any>((reject) => {
      firebase.auth().sendPasswordResetEmail(email)
      .then(res => {
        console.log(res);
        alert('A link to change your password will be sent to you in a few moments.');
      }, err => reject(err));
    });
  }
}
